import { TranslatedComponent, translation } from '@hh.ru/front-static-app';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';

import FAQ from 'src/components/FAQ';

const TrlKeys = {
    title: 'career-platform.profession.faq.title',
};

const FAQProfession: TranslatedComponent = ({ trls }) => {
    const faq = useSelectorNonNullable((state) => state.pageProfession.profession.faq);

    if (!faq.length) {
        return null;
    }

    // Обновляем key т.к, событие аналитики не отправляется повторно при изменении вкладок на странице
    return <FAQ key={Date.now().toString()} title={trls[TrlKeys.title]} data={faq} />;
};

export default translation(FAQProfession);
